import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdContentCopy, MdCheck, MdVideocam } from "react-icons/md";

export default function MeetingInviteCard({ code, isOwn }) {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => console.error("Erreur de copie :", err));
  };

  const handleJoin = () => {
    sessionStorage.setItem("meetingCode", code);
    navigate("/reunion");
  };

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <MdVideocam style={{ fontSize: "20px" }} />
        <span style={{ fontWeight: 600, fontSize: "14px" }}>
          Invitation reunion
        </span>
      </div>
      <div style={codeContainerStyle}>
        <span style={codeStyle}>{code}</span>
        <button
          onClick={handleCopy}
          style={copyBtnStyle}
          title="Copier le code"
        >
          {copied ? (
            <MdCheck style={{ color: "#00b074", fontSize: "16px" }} />
          ) : (
            <MdContentCopy style={{ fontSize: "16px" }} />
          )}
        </button>
      </div>
      {!isOwn && (
        <button onClick={handleJoin} style={joinBtnStyle}>
          Rejoindre
        </button>
      )}
    </div>
  );
}

const cardStyle = {
  backgroundColor: "rgba(2, 51, 119, 0.15)",
  borderRadius: "8px",
  padding: "10px 12px",
  minWidth: "200px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  opacity: 0.85,
  fontSize: "13px",
};

const codeContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "rgba(0,0,0,0.1)",
  borderRadius: "6px",
  padding: "6px 10px",
};

const codeStyle = {
  fontFamily: "monospace",
  fontSize: "14px",
  fontWeight: 700,
  letterSpacing: "0.5px",
};

const copyBtnStyle = {
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: "2px",
  display: "flex",
  alignItems: "center",
};

const joinBtnStyle = {
  backgroundColor: "#096ae7",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "8px 0",
  fontSize: "14px",
  fontWeight: 600,
  cursor: "pointer",
  width: "100%",
  textAlign: "center",
};
